export default __webpack_public_path__ + "static/media/message-regular.86a67286.svg";